<template>
  <div class="input-group-append ec-ds-search-button-container d-none d-md-flex w-100 search-btn-size">
    <button class="btn "
            type="button" @click="changeQuery()">
      <i class="material-icons align-bottom ml-1">search</i>
    </button>
  </div>
</template>

<script>
export default {
  name: "SearchButton",
  props: {
    changeQuery: Function
  }
}
</script>

<style lang="scss" scoped>
.search-btn-size {
  flex-basis: 0;
}

// div {
//   border: 1px solid black;
//   border-left-width: 0;
//   border-radius: 0 4px 4px 0;
// }

button {
  border: 0;
  background-color: #0e47cb;
  color: #fff;
  border-radius: 0px 4px 4px 0px;
}

button:hover {
  border: 0;
  background-color: #3e6cd5;
  color: #fff;
  border-radius: 0px 4px 4px 0px;
}

.ec-ds-search-btn {
  height: 100%;
}

@media screen and (max-width: 767.5px) {
  .ec-ds-search-button-container {
    margin-left: 0;
  }
}
</style>
